import { Link } from 'react-router-dom'
import { Info } from 'lucide-react'
import { t } from '@/lib/ui'

// Persistent slim disclaimer, on EVERY page (DESIGN-BRIEF §3, standing rule #4).
// "ArkkiKELA on arkkityyppinen tutkimusmalli — ei Kelan palvelu." + a link to
// the front-page explanation (the manifesto). The pale-petrol tint is the first
// signal that this is not kela.fi (no Kela blue anywhere).
export function DisclaimerBanner() {
  return (
    <div className="border-b border-hairline bg-accent-soft text-ink">
      <div className="mx-auto flex max-w-shell items-center gap-x-2 gap-y-1 px-4 py-1.5 text-sm sm:flex-row sm:flex-wrap">
        <Info className="h-4 w-4 shrink-0 text-accent" aria-hidden="true" />
        <p className="font-medium">{t('banner.disclaimer')}</p>
        <Link
          to="/#manifesti"
          className="text-accent underline decoration-hairline underline-offset-2 hover:decoration-accent"
        >
          {t('banner.whatIsThis')} →
        </Link>
      </div>
    </div>
  )
}
